import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myPhotoMainAdd(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('imageBase64', payload.imageBase64);
    params.append('restriction', payload.restriction);
    return axios.post(config.apiUri + "member/myPhotoMainAddApi.php", params, {
      timeout: 30000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メイン写真を申請しました。12時間以内に申請結果をメールでお知らせします'} });
      action.callback();
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment:res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('imageBase64', payload.imageBase64);
    params.append('secret', payload.secret);
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo'],
    		},
      });
      action.callback();
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment:res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myPhotoSecret(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'secret');
    params.append('id', payload.id);
    params.append('secret', payload.secret);
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: (action.payload.secret === 1) ? 'シークレットに設定しました' : 'シークレットを解除しました'} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('id', payload.id);
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo'],
    		},
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoMainRequest(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'mainRequest');
    params.append('id', payload.id);
    params.append('restriction', payload.restriction);
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メイン写真に申請しました'} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoMainRequestStop(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'mainRequestStop');
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo','request'],
    		},
      });
    }
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メイン写真の申請を停止しました'} });
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoMainDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'mainDel');
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メイン写真を削除しました'} });
      action.callback();
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoMainRestrictionEdit(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'mainRestriction');
    params.append('restriction', payload.restriction);
    return axios.post(config.apiUri + "member/myPhotoEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['photo','request'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: 'メイン写真の公開制限を変更しました'} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPhotoRekognitionCheck(action) {
  const {res} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('imageBase64', payload.imageBase64);
    return axios.post(config.apiUri + "member/myPhotoRekognitionCheckApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
  }, action.payload);
  if (res) {
    action.callback(res.data);
  }
}

const saga = [
  takeLatest('MY_PHOTO_MAIN_ADD', myPhotoMainAdd),
  takeLatest('MY_PHOTO_MAIN_REQUEST', myPhotoMainRequest),
  takeLatest('MY_PHOTO_MAIN_REQUEST_STOP', myPhotoMainRequestStop),
  takeLatest('MY_PHOTO_RESTRICTION_EDIT', myPhotoMainRestrictionEdit),
  takeLatest('MY_PHOTO_MAIN_DEL', myPhotoMainDel),
  takeLatest('MY_PHOTO_SECRET', myPhotoSecret),
  takeLatest('MY_PHOTO_DEL', myPhotoDel),
  takeLatest('MY_PHOTO_ADD', myPhotoAdd),
  takeLatest('MY_PHOTO_REKOGNITION_CHECK', myPhotoRekognitionCheck),
];

export default saga;
